import { render } from "./AdminBooking.vue?vue&type=template&id=154ccf12&scoped=true"
import script from "./AdminBooking.vue?vue&type=script&lang=js"
export * from "./AdminBooking.vue?vue&type=script&lang=js"

import "./AdminBooking.vue?vue&type=style&index=0&id=154ccf12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154ccf12"]])

export default __exports__